import React, { memo } from 'react';
import { Section } from './Shared';
const planComparison = [{
  situation: 'Paciente que vuelve después de 2 semanas',
  without: 'Le preguntás cómo se sentía',
  with: 'Abrís su ficha y retomás exacto'
}, {
  situation: 'Dirección/auditoría pide tu registro clínico',
  without: 'Improvisás papeles sueltos',
  with: 'Legajo profesional firmado'
}, {
  situation: 'Insumos en plena jornada',
  without: 'Te das cuenta cuando faltan',
  with: 'Control semanal anticipado'
}, {
  situation: 'Mostrarle al paciente su progreso',
  without: 'Lo decís de memoria',
  with: 'Evolución documentada visible'
}, {
  situation: 'Cierre de sesión',
  without: 'Se va sin pauta clara',
  with: 'Tarjeta post-sesión en mano'
}, {
  situation: 'Querés vender paquetes de sesiones',
  without: 'No sabés cómo presentarlo',
  with: 'Estructura de 4, 8 y 12 sesiones lista'
}, {
  situation: 'Necesitás recuperar un paciente inactivo',
  without: 'No sabés qué escribirle',
  with: 'Guión de WhatsApp listo para enviar'
}, {
  situation: 'Querés subir tus precios',
  without: 'Miedo a perder pacientes',
  with: 'Sistema de valor percibido paso a paso'
}];
export const UpgradeComparison = () => {
  return <Section className="max-w-5xl" data-id="element-360">
      <div className="text-center mb-10" data-id="element-361">
        <h2 className="text-2xl md:text-4xl font-serif font-bold mb-3" data-id="element-362">
          🚀 ¿Qué agrega el Acelerador de Consultorio?
        </h2>
        <p className="text-brand-text/70 text-sm md:text-base max-w-2xl mx-auto" data-id="element-363">
          Lo que cambia en tu día a día cuando tenés el sistema completo.
        </p>
      </div>

      <div className="glass-panel rounded-3xl p-5 md:p-8 bg-white/80 border-brand-rose/30" data-id="element-364">
        {/* Desktop 3-col table */}
        <div className="hidden md:block" data-id="element-365">
          <div className="grid grid-cols-3 gap-4 text-xs font-bold uppercase tracking-wide text-brand-text/60 border-b border-brand-pink/30 pb-3 mb-3" data-id="element-366">
            <div data-id="element-367">Situación</div>
            <div className="text-red-500" data-id="element-368">❌ Sin Acelerador</div>
            <div className="text-brand-green" data-id="element-369">✅ Con Acelerador</div>
          </div>
          <div className="space-y-1" data-id="element-370">
            {planComparison.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 text-sm text-brand-text/80 py-3 border-b border-brand-pink/15 last:border-0" data-id="element-371">
                <div className="font-semibold text-brand-text" data-id="element-372">
                  {row.situation}
                </div>
                <div className="text-red-600/80" data-id="element-373">{row.without}</div>
                <div className="text-brand-green font-medium" data-id="element-374">{row.with}</div>
              </div>)}
          </div>
        </div>

        {/* Mobile stacked */}
        <div className="md:hidden space-y-4" data-id="element-375">
          {planComparison.map((row, i) => <div key={i} className="border-b border-brand-pink/20 pb-4 last:border-0 last:pb-0" data-id="element-376">
              <p className="text-sm font-bold text-brand-text mb-2" data-id="element-377">
                {row.situation}
              </p>
              <div className="text-xs text-red-600/80 mb-1" data-id="element-378">
                ❌ {row.without}
              </div>
              <div className="text-xs text-brand-green font-medium" data-id="element-379">
                ✅ {row.with}
              </div>
            </div>)}
        </div>

        <p className="text-center text-sm md:text-base font-medium text-brand-rose italic mt-6 pt-4 border-t border-brand-pink/20" data-id="element-380">
          Una sola sesión recuperada con esta guía ya paga la diferencia de
          precio.
        </p>
      </div>
    </Section>;
};